import { DayVolume, ScheduleDay, WeekDay, WeekDriver } from '../../api/services/schedule.service';

const DAY_MS = 86400000;

export const isoDay = (d: Date) => d.toISOString().slice(0, 10);

/** The Friday that ends the FedEx week holding this local calendar day. */
export function weekEndingFor(date: Date): string {
  const utc = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  return isoDay(new Date(utc.getTime() + ((5 - utc.getUTCDay() + 7) % 7) * DAY_MS));
}

export const shiftWeek = (weekEnding: string, weeks: number) => isoDay(
  new Date(new Date(`${weekEnding}T00:00:00Z`).getTime() + weeks * 7 * DAY_MS),
);

export const toggleDay = (days: ScheduleDay[], day: ScheduleDay) => (
  days.includes(day) ? days.filter((d) => d !== day) : [...days, day]
);

export interface DayRoom {
  stops: number;
  packages: number;
  /** Still under capacity once the day's pickups are counted too? */
  stopsWithPickups: number;
  packagesWithPickups: number;
}

/** Capacity left after the day's volume; negative means understaffed. */
export function roomLeft(day: Pick<WeekDay, 'maxStops' | 'maxPackages'>, volume: DayVolume): DayRoom {
  const stops = day.maxStops - volume.stops;
  const packages = day.maxPackages - volume.packages;
  return {
    stops,
    packages,
    stopsWithPickups: stops - volume.pickupStops,
    packagesWithPickups: packages - volume.pickupPackages,
  };
}

/** The changes to send: every driver on the week, the server keeps the differences. */
export const driverChanges = (drivers: WeekDriver[]) => drivers.map((d) => ({ accountId: d.accountId, days: d.days }));

export type DayVerdict = 'short' | 'tight' | 'ok' | 'unknown';

/** Short: over capacity. Tight: fits only if pickups do not count against it. */
export function verdict(day: WeekDay): DayVerdict {
  if (!day.volume || day.closed) return 'unknown';
  const room = roomLeft(day, day.volume);
  if (room.stops < 0 || room.packages < 0) return 'short';
  if (room.stopsWithPickups < 0 || room.packagesWithPickups < 0) return 'tight';
  return 'ok';
}
